import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { ServiceService } from '../../../../../../services/service.service';
import {
    ServicePatternGridObject,
} from '@libs/types/src/services/object-type/service/service-pattern.object';

interface State {
    servicePatterns: ServicePatternGridObject | null,
}

const defaultState: State = {
    servicePatterns: null,
};

@Injectable()
export class ServicePatternsDocumentPageStore extends ComponentStoreFactory<State> {

    public structure$ = this.data.servicePatterns$.firstGridItem<ServicePatternGridObject>();

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }

}
